import React from 'react';
import { Container } from 'reactstrap';

export default props => (
    <Container fluid={true} className="appBody">
      {props.children}
    </Container>
);
